import { useForm } from "@core/features/form";
import { useDialog } from "@platform/store";
import { codeSchema } from "./orgCodeDialog.schemas";
import { useSubmitCode } from "@platform/features/invitation/hooks/useSubmitCode";
import { OrgCodeDialog } from "./OrgCodeDialog";

/**
 * Container component that handles business logic for OrgCodeDialog.
 * Manages form state, dialog state, and code submission.
 */
export function OrgCodeDialogContainer() {
  const { activeDialog, closeDialog, openDialog } = useDialog();

  const isOpen = activeDialog === "code";

  const submitCode = useSubmitCode();

  const { form, handleSubmit, handleClose } = useForm({
    schema: codeSchema,
    defaultValues: {
      code: "",
    },
    onSubmit: submitCode.mutateAsync,
    onClose: () => closeDialog(),
  });

  const { isSubmitting, isValid, isSubmitSuccessful } = form.formState;

  return (
    <OrgCodeDialog
      isOpen={isOpen}
      isSubmitSuccessful={isSubmitSuccessful}
      isSubmitting={isSubmitting}
      isValid={isValid}
      form={form}
      onSubmit={handleSubmit}
      onClose={handleClose}
      onSecondaryClick={() => openDialog("orgLookup")}
    />
  );
}

export default OrgCodeDialogContainer;

